import { createSelector } from 'reselect';
export const selectObjBuilderState = state => state.navObjBuilderMenu;
export const selectObjBuilderMenuItems = createSelector(selectObjBuilderState, ({
  items
}) => items || []);
export const selectHasObjBuilderMenuItems = createSelector(selectObjBuilderMenuItems, items => items.length > 0);